
import { HowUseCard } from "../../components/how-use-card/HowUseCard";
import "./HowUse.css";

export function HowUse() {
  return (
    <div className="container">
      <h2 className="provider-title">
        ¿Cómo funciona?
      </h2>
    <div className="container howuse-grid">
      <HowUseCard
        image="/assets/icons/porcentaje.svg"
        title="Ventajas Exclusivas"
        text="Ofertas en multitud de restaurantes y muchas otras ventajas con nuestro programa Vital.​"
      />
      <HowUseCard
        title="La mejor opción"
        image="/assets/icons/check.svg"
        text="Una selección inigualable de profesionales y productos de la salud para todo lo que quieras.​"
      />
      <HowUseCard
        title="Opiniones de los usuarios"
        image="/assets/icons/star.svg"
        text="Recomendaciones y opiniones de una gran comunidad.​"
      />
      <HowUseCard
        title="Sistema de reservas de una manera sencilla"
        image="/assets/icons/calendar.svg"
        text="Agenda tus citas clinicas de una manera inmediata, gratuita, estés donde estés. Evita largas filas en un consultorio y planifica en tu mejor día.​"
      />
    </div>
    </div>
  );
}